import React from 'react';
import { Stack } from '@mui/material';
import { RuleList } from '../../rules/RuleList';
import { RuleModal } from '../../rules/RuleModal';

const RulesTab: React.FC = () => {
  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="flex-end">
        <RuleModal />
      </Stack>
      <RuleList />
    </Stack>
  );
};

export default RulesTab;